import {
  Component,
  NgZone,
  ApplicationRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core"
import $ from "jquery"
import TemplateString from "./film-search.component.html"

import ScrollMagic from "scrollmagic"

import { Subscription, fromEvent } from "rxjs"
import { debounceTime } from "rxjs/operators"

@Component({
  selector: "app-film-search",
  template: TemplateString,
  inputs: [
    "query",
    "currentGenre",
    "currentCountry",
    "currentLanguage",
    "currentInterest",
    "currentTheme",
    "currentFormat",
    "currentFestival",
    "currentYear",
    "archive",
    "activeFestival",
    "viewing",
    "teenScreen",
    "films",
    "year",
    "currentGrade",
  ],
})
export class FilmSearchComponent implements OnInit {
  query: string
  archive: boolean
  currentGenre: string
  currentCountry: string
  currentLanguage: string
  currentInterest: string
  currentTheme: string
  currentFormat: string
  currentFestival: string
  activeFestival: string
  currentGrade: string
  currentYear: number
  viewing: string
  teenScreen: boolean
  windowHeight: number
  windowWidth: number
  options: Array<string>
  genres: object
  countries: object
  languages: object
  interests: object
  formats: object
  years: object
  year: number
  moods: object
  grades: object
  themes: object
  festivals: object
  films: Array<object>
  pagination: Array<object>
  scene: any
  keyupSub: Subscription
  @ViewChild("searchQuery") inputElRef: ElementRef

  @Output() queryEvent = new EventEmitter<string>()
  @Output() filterEvent = new EventEmitter<object>()

  constructor(private ngzone: NgZone, private appref: ApplicationRef) {
    this.windowHeight = $(window).height()
    this.windowWidth = window.innerWidth

    this.paginationSetup()
  }

  ngOnInit() {
    this.scrollMagicInit()

    var collection = []
    this.films.forEach((e) => {
      Object.keys(e["fields"]).forEach((i) => {
        collection.push(i)
      })
    })
    this.options = Array.from(new Set(collection)).sort(function (a, b) {
      return b - a
    })

    this.refreshSearchOptions(this.options, this.films)

    $(".films__spinner").hide()
  }

  ngAfterViewInit() {
    this.ngzone.runOutsideAngular(() => {
      this.keyupSub = fromEvent(this.inputElRef.nativeElement, "keyup")
        .pipe(debounceTime(1000))
        .subscribe((keyboardEvent) => {
          this.query = keyboardEvent["target"].value
          this.sendQuery()
        })
    })
    this.checkForParam()
  }

  scrollMagicInit() {
    const controller = new ScrollMagic.Controller()

    setTimeout(() => {
      let duration =
        $(".films__display").height() - $(".films__search").height() - 88

      duration = duration > 0 ? duration : 0

      if (duration > $(".films__search").height() - 275) {
        this.scene = new ScrollMagic.Scene({
          triggerElement: ".films__search-wrap",
          offset: $(window).height() / 2 - 40,
          duration: duration,
        })
          .setPin(".films__search", { pushFollowers: false })
          .addTo(controller)
          .setClassToggle(".films__search", "mobile")
      }
    }, 100)
  }

  toggleOptions(event, type, initial) {
    var selection = event.target.parentElement.classList

    if (selection.contains("selected")) {
      this.sendFilter(type, initial)
      selection.remove("selected")
      selection.add("closed")
    } else if (!selection.contains("closed")) {
      selection.toggle("closed")
    } else {
      $(
        ".films__search__categories > div:not(.films__search__clear-all)",
      ).addClass("closed")
      selection.toggle("closed")
    }
  }

  toggleMobile() {
    if (window.innerWidth < 700) {
      $(".films__search__title").toggleClass("open")
      $(".films__search--wrap").slideToggle(300)
      $(".films__display").toggleClass("open")
    }
  }

  onResize() {
    if (
      window.innerWidth > 700 &&
      $(window).height() == this.windowHeight &&
      window.innerWidth !== this.windowWidth
    ) {
      $(".films__search--wrap").slideDown(300)
      $(".films__search__title").removeClass("open")
      $(".films__display").removeClass("open")
    } else if (
      $(window).height() == this.windowHeight &&
      window.innerWidth !== this.windowWidth
    ) {
      $(".films__search--wrap").slideUp(300)
      $(".films__search__title").removeClass("open")
      $(".films__display").removeClass("open")
    }
  }

  sendQuery() {
    this.queryEvent.emit(this.query)
    if (window.innerWidth >= 960) {
      this.reInitScene()
    }
  }

  setFilter(current, filter, event) {
    this[current] = filter
    this.sendFilter(current, this[current])
    event.target.parentElement.parentElement.classList.toggle("selected")
    if (window.innerWidth >= 960) {
      this.reInitScene()
    }
  }

  sendFilter(type, content) {
    var filterContainer = {
      type: type,
      content: content,
    }
    this.filterEvent.emit(filterContainer)
  }

  refreshSearchOptions(fields, films) {
    var options = []

    fields.forEach((e) => {
      var collection = []
      Object.keys(films).forEach((key) => {
        if (typeof films[key]["fields"][e] !== "undefined") {
          collection.push(films[key]["fields"][e])
        }
      })

      options[e] = Array.from(new Set([].concat(...collection))).sort(function (
        a,
        b,
      ) {
        return b - a
      })

      this.genres = options["genres"]
      this.countries = options["countries"]
      this.languages = options["languages"]
      this.interests = options["interests"]
      this.formats = options["film_type"]
      this.years = options["festival_year"]
      this.moods = options["moods"]
      this.grades = options["grades"]
      this.themes = options["theme"]
      this.festivals = options["festival"]
    })
  }

  clearAll() {
    var initial = [
      {
        type: "currentFestival",
        initial: "FESTIVAL/PROGRAM",
        selector: ".films__search__festival",
      },
      {
        type: "currentYear",
        initial: "YEAR FEATURED",
        selector: ".films__search__year",
      },
      {
        type: "currentGenre",
        initial: "GENRE",
        selector: ".films__search__genre",
      },
      {
        type: "currentCountry",
        initial: "COUNTRY",
        selector: ".films__search__country",
      },
      {
        type: "currentLanguage",
        initial: "LANGUAGE",
        selector: ".films__search__language",
      },
      {
        type: "currentInterest",
        initial: "TOPIC/INTEREST",
        selector: ".films__search__topic",
      },
      {
        type: "currentTheme",
        initial: "THEME",
        selector: ".films__search__theme",
      },
      {
        type: "currentFormat",
        initial: "FORMAT",
        selector: ".films__search__format",
      },
      {
        type: "currentGrade",
        initial: "GRADE",
        selector: ".films__search__grade",
      },
    ]

    var selections = $(".films__search__categories > div")

    initial.forEach((e) => {
      if (!this.archive && e.type == "currentFestival") {
      } else {
        $(e.selector).removeClass("selected")
        $(e.selector).addClass("closed")
        this.sendFilter(e.type, e.initial)
      }
    })

    this.reInitScene()
  }

  reInitScene() {
    if (this.scene) {
      this.scene.destroy(true)
    }
    this.scrollMagicInit()
    this.paginationSetup()
  }

  paginationSetup() {
    setTimeout(() => {
      this.pagination = $(".ngx-pagination li a")
      $(this.pagination).each((index, page) => {
        $(page).on("click", () => {
          setTimeout(() => {
            this.reInitScene()
          }, 100)
        })
      })
    }, 100)
  }

  checkForParam() {
    let hasYear = 0
    for (let i in this.years) {
      if (this.years[i] == this.year) {
        hasYear = 1
      }
    }

    if (hasYear == 1) {
      $(".films__search__year").addClass("selected")
      this.sendFilter("currentYear", this.year)
    }
  }
}
